
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeTankerOutlined as ObiVesselTypeTankerOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-tanker-outlined.js';
 
 
 

 
 export const ObiVesselTypeTankerOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-tanker-outlined',
   elementClass: ObiVesselTypeTankerOutlinedElement,
   events: {
     
   }
  });
 
 